<script>
    import ElementTypeIcon from './ElementTypeIcon.svelte';
    import {sgettext} from '../../i18n.js';

    export let type = '';
</script>

<span>
    <ElementTypeIcon {type} />
    <span>{sgettext(type)}</span>
</span>